import Button from "../Button/button";

const QuickSelectBoxes = ({
  isUsingSubscriptionTickets,
  quickBuySelections,
  multibuyLowerQuantity,
  multibuyLowerPercent,
  multibuyUpperQuantity,
  multibuyUpperPercent,
  quantity,
  addQuickSelect,
  maxTicketsPerUser,
}: {
  isUsingSubscriptionTickets: boolean;
  quickBuySelections: number[];
  multibuyLowerQuantity: number;
  multibuyLowerPercent: number;
  multibuyUpperQuantity: number;
  multibuyUpperPercent: number;
  quantity: string;
  addQuickSelect: (event: React.MouseEvent<HTMLButtonElement>, quantity: number) => void;
  maxTicketsPerUser: number;
}) => {
  return (
    <div className={"quick-select min-h-[90px]" + (isUsingSubscriptionTickets ? " hidden" : "")}>
      <p className="text-[#898994] font-jost text-xs font-medium leading-5">Quick Select</p>
      <div className="grid grid-cols-4 gap-[5px] lg:gap-2 mt-2">
        {quickBuySelections.map((qs, index: number) => (
          <div className="flex flex-col relative" key={index}>
            {multibuyLowerQuantity == qs && multibuyLowerPercent > 0 && (
              <span className="bg-[#FF8200] px-1 min-h-[15px] text-[9px] font-bold leading-normal text-white rounded-tl-lg rounded-tr-lg absolute w-full text-center">
                SAVE{" "}
                {(multibuyLowerPercent * 100).toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 0,
                })}
                %
              </span>
            )}
            {multibuyUpperQuantity == qs && multibuyUpperPercent > 0 && (
              <span className="bg-[#EB3B2C] px-1 min-h-[15px] text-[9px] font-bold leading-normal text-white rounded-tl-lg rounded-tr-lg absolute w-full text-center">
                SAVE{" "}
                {(multibuyUpperPercent * 100).toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 0,
                })}
                %
              </span>
            )}
            <Button
              text={`${qs} tickets`}
              className={`min-h-[64px] py-4 text-secondary text-center text-xs font-medium leading-6 rounded-lg !border-[1.5px] !border-solid ${quantity === qs.toString() ? "border-[#FF8200] bg-[#FFF3E6]" : "border-black/[0.08] bg-[#F2F2F2]"}`}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => addQuickSelect(event, qs)}
            />
            {multibuyLowerQuantity == qs && multibuyLowerPercent > 0 && (
              <span className="text-[#FF8200] text-[9px] font-bold leading-normal absolute w-full text-center bottom-[9px]">
                POPULAR
              </span>
            )}
            {multibuyUpperQuantity == qs && multibuyUpperPercent > 0 && (
              <span className="text-[#EB3B2C] text-[9px] font-bold leading-normal absolute w-full text-center bottom-[9px]">
                {(index === 0 && "POPULAR") || "BEST VALUE"}
              </span>
            )}
            {maxTicketsPerUser === qs && multibuyLowerQuantity !== qs && multibuyUpperQuantity !== qs && (
              <span className="text-[#3abc12] text-[9px] font-bold leading-normal absolute w-full text-center bottom-[9px]">
                MOST CHANCES
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickSelectBoxes;
